import {
    REQUEST_SCRAP_RECORDS,
    FETCH_SCRAP_RECORDS_SUCCESS,
    FETCH_SCRAP_RECORDS_FAILURE,
    SELECT_SCRAP_RECORD,
    RESET_CURRENT_SCRAP_RECORD,
    REQUEST_SCRAP_RECORD_DETAIL,
    FETCH_SCRAP_RECORD_DETAIL_SUCCESS,
    FETCH_SCRAP_RECORD_DETAIL_FAILURE,
    FETCH_INVENTORY_SCRAP,
    FETCH_INVENTORY_SCRAP_SUCCESS,
    FETCH_INVENTORY_SCRAP_FAILURE,
    REQUEST_CREATING_SCRAP_RECORD,
    CREATE_SCRAP_RECORD_SUCCESS,
    CREATE_SCRAP_RECORD_FAILURE,
    REQUEST_EDITING_SCRAP_RECORD,
    EDIT_SCRAP_RECORD_SUCCESS,
    EDIT_SCRAP_RECORD_FAILURE
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    currentScrapRecord: null,
    currentScrapRecordDetail: null,
    isLoading: false,
    error: null,
    detailIsLoading: false,
    detailError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    inventories: null,
    inventoriesIsLoading: false,
    inventoriesError: null,
    scrapRecordIsCreating: false,
    scrapRecordCreateError: null,
    scrapRecordCreated: false,
    scrapRecordIsEditing: false,
    scrapRecordEditError: null,
    scrapRecordEdited: false
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        // Inventory Adjustment action handlers
        case REQUEST_SCRAP_RECORDS:
            return { ...state, error: null, isLoading: true };
        case FETCH_SCRAP_RECORDS_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_SCRAP_RECORDS_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_SCRAP_RECORD:
            return { ...state, currentScrapRecord: action.payload };
        case RESET_CURRENT_SCRAP_RECORD:
            return { ...state, currentScrapRecord: null, currentScrapRecordDetail: null };
        case REQUEST_SCRAP_RECORD_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_SCRAP_RECORD_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentScrapRecordDetail: action.payload.data, detailError: null, detailIsLoading: false };
        case FETCH_SCRAP_RECORD_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case FETCH_INVENTORY_SCRAP:
            return { ...state, inventories: null, inventoriesIsLoading: true, inventoriesError: null };
        case FETCH_INVENTORY_SCRAP_SUCCESS:
            return { ...state, inventories: action.payload.data, inventoriesIsLoading: false, inventoriesError: null };
        case FETCH_INVENTORY_SCRAP_FAILURE:
            const inventoriesError = action.payload || { message: action.payload.message };
            return { ...state, inventories: null, inventoriesIsLoading: false, inventoriesError: inventoriesError };
        case REQUEST_CREATING_SCRAP_RECORD:
            return { ...state, scrapRecordIsCreating: true, scrapRecordCreateError: null, scrapRecordCreated: false };
        case CREATE_SCRAP_RECORD_SUCCESS:
            return { ...state, scrapRecordIsCreating: false, scrapRecordCreateError: null, scrapRecordCreated: true };
        case CREATE_SCRAP_RECORD_FAILURE:
            const scrapRecordCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, scrapRecordIsCreating: false, scrapRecordCreateError: scrapRecordCreateError, scrapRecordCreated: false };
        case REQUEST_EDITING_SCRAP_RECORD:
            return { ...state, scrapRecordIsEditing: true, scrapRecordEditError: null, scrapRecordEdited: false };
        case EDIT_SCRAP_RECORD_SUCCESS:
            return { ...state, scrapRecordIsEditing: false, scrapRecordEditError: null, scrapRecordEdited: true };
        case EDIT_SCRAP_RECORD_FAILURE:
            const scrapRecordEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, scrapRecordIsEditing: false, scrapRecordEditError: scrapRecordEditError, scrapRecordEdited: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/scrapRecords_reducer.js